export const EmailCheck = (email: string) => {
  // Updated regex to support longer TLDs like .college, .education etc
  // Allows TLDs between 2-63 characters per RFC specs
  const emailRegex = /^[a-zA-Z0-9._-]+(\+[a-zA-Z0-9._-]+)?@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$/;
  return emailRegex.test(email);
}